export default __webpack_public_path__ + "static/media/Instagram.5b663cf3.svg";